import React from "react";

export const getResumePreviewUrl = url => {
  if (!url) return "";

  const resumeUrl = String(url);
  const cleanUrl = resumeUrl.split(/[?#]/)[0].toLowerCase();
  let cleanPath = cleanUrl;

  try {
    cleanPath = decodeURIComponent(new URL(resumeUrl, window.location.origin).pathname).toLowerCase();
  } catch (error) {
    cleanPath = cleanUrl;
  }

  if (cleanPath.endsWith(".pdf") || cleanUrl.endsWith(".pdf")) {
    return resumeUrl.includes("#") ? resumeUrl : `${resumeUrl}#toolbar=1&navpanes=1&scrollbar=1`;
  }

  if (cleanPath.endsWith(".doc") || cleanPath.endsWith(".docx") || cleanUrl.endsWith(".doc") || cleanUrl.endsWith(".docx")) {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(resumeUrl)}`;
  }

  return `https://docs.google.com/gview?url=${encodeURIComponent(resumeUrl)}&embedded=true`;
};

const ResumePreviewPanel = ({
  resumeUrl,
  title = "Resume Preview",
  height = "100%",
  minHeight = "520px",
  showShellBorder = true,
  wrapperStyle = {},
  bodyStyle = {},
  iframeStyle = {},
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      height,
      minHeight,
      background: "#f8fafc",
      border: showShellBorder ? "1px solid #dbe4f0" : "none",
      borderRadius: showShellBorder ? 10 : 0,
      overflow: "hidden",
      ...wrapperStyle,
    }}
  >
    <div
      style={{
        padding: "0.85rem 1.25rem",
        borderBottom: "1px solid #dbe4f0",
        background: "#fff",
        fontWeight: 700,
        fontSize: 13,
        color: "#0f172a",
      }}
    >
      {title}
    </div>

    <div
      style={{
        flex: 1,
        padding: "0.75rem",
        display: "flex",
        minHeight: 0,
        ...bodyStyle,
      }}
    >
      {resumeUrl ? (
        <iframe
          src={getResumePreviewUrl(resumeUrl)}
          title={title}
          style={{
            width: "100%",
            height: "100%",
            minHeight: 0,
            borderRadius: 10,
            border: "1px solid #dbe4f0",
            background: "#2b2b2b",
            ...iframeStyle,
          }}
        />
      ) : (
        <div className="m-auto text-muted d-flex flex-column align-items-center gap-2">
          <i className="bi bi-file-earmark-x" style={{ fontSize: 36, color: "#cbd5e1" }} />
          <span style={{ fontSize: 13 }}>No resume uploaded</span>
        </div>
      )}
    </div>
  </div>
);

export default ResumePreviewPanel;
